import React, { useState, useEffect } from 'react';
import { Box, Skeleton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const gridSx = {
    borderRadius: 0.5,
    boxShadow: 1,
    border: '1px solid #dde7eb80',
    "& .MuiDataGrid-cell:focus": {
        outline: "none !important", // Disable focus outline
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
        backgroundColor: "#f9f9f9", // Even row background color
    },
    "& .MuiDataGrid-row:nth-of-type(odd)": {
        backgroundColor: "#ffffff", // Odd row background color
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
        justifyContent: "center", // Center header text
    },
    "& .MuiDataGrid-cell--textLeft": {
        textAlign: "center",
    },
    "& .MuiDataGrid-container--top [role=row]": {
        backgroundColor: "#ffdddb"
    }
};

const DataGridTable = ({
    initialRows,
    initialColumns,
    initialPageSize,
    initialRowHeight,
    hideToolbar = false,
    // server-side pagination (opt-in)
    serverMode = false,
    rowCount,
    paginationModel,
    onPaginationModelChange,
    loading: loadingProp = false,
    getRowId,
    sx: sxProp,
}) => {
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);

    useEffect(() => {

        const fetchData = async () => {
            setTimeout(() => {
                setRows(initialRows);
                setLoading(false);
            }, 100);
        };

        fetchData();
    }, [initialRows]);
    const renderSkeletonRows = () => {
        return Array(5)
            .fill(0)
            .map((_, index) => (
                <div key={index} style={{ display: 'flex', padding: '10px', marginBottom: '10px' }}>
                    {initialColumns.map((col, colIndex) => (
                        <Skeleton
                            key={colIndex}
                            variant="rectangular"
                            width={200}
                            height={40}
                            style={{ margin: '0 0' }}
                        />
                    ))}
                </div>
            ));
    };

    const toolbarSlot = hideToolbar ? undefined : { Toolbar: GridToolbar };

    // Server-side pagination: parent owns rows/page/total and refetches on change.
    if (serverMode) {
        return (
            <Box sx={{ marginTop: "20px" }}>
                <DataGrid
                    sx={{ ...gridSx, ...sxProp }}
                    rows={initialRows || []}
                    columns={initialColumns}
                    getRowId={getRowId || ((row) => row._id ?? row.id)}
                    paginationMode="server"
                    rowCount={rowCount ?? 0}
                    paginationModel={paginationModel}
                    onPaginationModelChange={onPaginationModelChange}
                    pageSizeOptions={[5, 10, 25]}
                    loading={loadingProp}
                    keepNonExistentRowsSelected
                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    components={toolbarSlot}
                    rowHeight={initialRowHeight}
                />
            </Box>
        );
    }

    const rowsWithId = rows?.map((row, index) => ({
        ...row,
        id: index,
    }));

    // Client-side pagination (default, unchanged behavior).
    return (
        <Box sx={{ marginTop: "20px" }}>
            {loading ? (
                <Box sx={{ borderRadius: "20px", boxShadow: "0px 0px 8px #cccccc", padding: "10px", maxHeight: '500px' }}>
                    {renderSkeletonRows()}
                </Box>
            ) : (
                <DataGrid
                    sx={{ ...gridSx, ...sxProp }}
                    rows={rowsWithId}
                    columns={initialColumns}

                    initialState={{

                        pagination: { paginationModel: { pageSize: initialPageSize || 10 } },
                    }}
                    pageSizeOptions={[5, 10, 25]}

                    disableSelectionOnClick
                    components={toolbarSlot}
                    rowHeight={initialRowHeight}
                />
            )}
        </Box>
    );
};

export default DataGridTable;
